import { Platform, StyleSheet } from 'react-native'

import { theme } from '../../../theme'

export const privacyDataControlsModalStyles = StyleSheet.create({
  modalOuter: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  sheet: {
    width: '100%',
    maxWidth: 560,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: theme.gray[700],
    backgroundColor: '#111827',
    paddingHorizontal: 16,
    paddingVertical: 14,
    ...(Platform.OS === 'android' ? { elevation: 8 } : {}),
  },
  title: {
    color: theme.white,
    fontSize: 18,
    fontWeight: '700',
  },
  subtitle: {
    color: theme.gray[400],
    fontSize: 13,
    marginTop: 4,
    marginBottom: 12,
  },
  section: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.gray[700],
    backgroundColor: '#1B2436',
    paddingHorizontal: 12,
    paddingVertical: 12,
    marginBottom: 10,
  },
  sectionTitle: {
    color: theme.white,
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 4,
  },
  sectionHint: {
    color: theme.gray[400],
    fontSize: 12,
    lineHeight: 18,
  },
  rowBetween: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  exportButton: {
    marginTop: 10,
    minHeight: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#8B5CF6',
    backgroundColor: '#8B5CF6',
    alignItems: 'center',
    justifyContent: 'center',
  },
  exportButtonPressed: {
    opacity: 0.9,
  },
  exportButtonDisabled: {
    opacity: 0.6,
  },
  exportButtonText: {
    color: theme.white,
    fontSize: 13,
    fontWeight: '600',
  },
  helperText: {
    marginTop: 8,
    color: theme.gray[400],
    fontSize: 12,
  },
  deleteButton: {
    marginTop: 10,
    minHeight: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#EF4444',
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteButtonPressed: {
    backgroundColor: 'rgba(239,68,68,0.12)',
  },
  deleteButtonText: {
    color: '#F87171',
    fontSize: 13,
    fontWeight: '700',
  },
  closeButton: {
    marginTop: 4,
    minHeight: 38,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: theme.gray[600],
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1F2937',
  },
  closeButtonPressed: {
    opacity: 0.85,
  },
  closeButtonText: {
    color: theme.gray[200],
    fontSize: 13,
    fontWeight: '600',
  },
})

